import Switch          from '@widesk-ui/components/form/Switch';
import View            from '@widesk-ui/components/View';
import useDesignTokens from '@/hooks/useDesignTokens';

/**
 * Un booléen qui peut être "mixte" (formes sélectionnées pas toutes d'accord) — ne jamais passer
 * `value={undefined}` à `Switch` : son `useEffect` interne force `onChange(false)` dès que `value`
 * est `undefined`, ce qui appliquerait silencieusement "false" à toute la sélection dès l'ouverture
 * de la sidebar. `value` reste donc un booléen sûr même en mode mixte, seul l'habillage visuel
 * change — le premier clic choisit la valeur qui s'applique ensuite à toutes les formes.
 */
export default function TriStateSwitch({ value, mixed, disabled, onChange }: {
	value: boolean;
	mixed?: boolean;
	disabled?: boolean;
	onChange: (checked: boolean) => void;
}) {
	const tokens = useDesignTokens();

	if (!mixed) return <Switch value={value} disabled={disabled} onChange={(checked: unknown) => onChange(!!checked)} />;

	return (
		<View row centerV gap={8}>
			<View
				br={999}
				p={2}
				style={{ border: `1.5px dashed ${tokens.color.primary}`, display: 'inline-flex' }}
			>
				<Switch value={value} disabled={disabled} onChange={(checked: unknown) => onChange(!!checked)} />
			</View>

			<View size={11.5} color={tokens.text.muted} style={{ fontStyle: 'italic' }}>
				Valeurs différentes
			</View>
		</View>
	);
}
